import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/celery/schedulelist`;
export const QueryKey = () => ['v3', 'admin', 'celery', 'schedules'] as const;
export type Payload = never;
export type Response = Models.Celery.ScheduleEntry[];
